function checkAnchor(id) {
	gsap.to(window, {
		duration: 1.2,
		scrollTo: {
			y: `#${id}`,
			// offsetY: $(window).height() * 0.2,
		},
		ease: 'power2.inOut',
		onComplete: function() {
			history.pushState("", document.title, window.location.pathname);
		}
	});
}


$(window).on("load", function() {
	// ryder特製anchor定位
	const _now = location.href.split("#")[0].split("/").slice(-1);
	let anchor = location.href.split("#")[1]

	if (anchor != undefined) {
		checkAnchor(anchor)
	}

	$("a").not("[href='javascript:;']").not("[href^='tel:']").not("[href^='mailto:']").not("[target='_blank']").not("[data-fancybox]").not("[data-share]").on("click", function(e) {
		e.preventDefault()

		let page = $(this).attr('href').split("#")[0].split("/").slice(-1);
		let anchor = $(this).attr('href').split("#")[1]

		if (_now[0] == page[0]) {
			// 同一頁不跳頁用滾的
			e.preventDefault()
			checkAnchor(anchor)
		} else {
			// 不同頁
			$("#preload").fadeIn(300, () => {
				location.href = $(this).attr('href')
			})
		}
	})
})